import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import logo from 'components/assets/img/logo.svg';
import { connect } from 'react-redux';

class Loader extends Component {

  render() {
    const { isLoadingContent } = this.props;
    return (
      <div className={"splash" + (isLoadingContent ? " splash--active" : "")}>
        <div className="splash__desc">
          <img src={logo} alt="PKS Oslo" />
          <i className="loader loader--splash"></i>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isLoadingContent: state.auth.isLoadingContent
  }
}

export default connect(mapStateToProps)(Loader);
